/**
 * 政策库菜单
 */
export default [
  
  {
    label: 'policyLibrary',  // 政策库
    permission: 'policy_library',
    img: true,
    id: 13,
    children: [
      {
        path: '/policy/policyLibrary/policyDictionary',
        label: 'policyDictionary',   // 政策字典
        permission: 'policy_library_index',
        id: '13-1',
      },
      {
        path: '/policy/policyLibrary/policyExpress',
        label: 'policyExpress',       // 政策速递
        permission: 'policy_express',
        id: '13-2'
      },
      {
        path: '/policy/policyLibrary/industryReport',
        label: 'industryReport',       // 行业报告
        permission: 'industry_report',
        id: '13-3'
      },
      {
        path: '/policy/policyLibrary/serviceTemplate',
        label: 'serviceTemplate',       // 业务模板
        permission: 'business_template',
        id: '13-4',
        children: [
          {
            path: '/policy/policyLibrary/documentTemplate',
            label: 'documentTemplate',  // 文档模板
            permission: 'business_template_document',
            id: '13-4-1',
            level: 2
          },
          {
            path: '/policy/policyLibrary/guidance',
            label: 'guidance',          // 办事指南
            permission: 'business_template_work_guide',
            id: '13-4-2',
            level: 2
          }
        ]
      }
    ]
  },
  {
    label: 'policyLibraryManagement',  // 政策库管理
    permission: 'management_background',
    img: true,
    id: 14,
    children: [
      {
        path: '/policy/policyLibraryManagement/policyLink',
        label: 'policyLink',          // 政策链接管理
        permission: 'management_background_policy_link',
        id: '14-1',
      },
      {
        path: '/policy/policyLibraryManagement/policyLibraryPermission',
        label: 'policyLibraryPermission',       // 政策库权限管理
        permission: 'management_background_auth',
        id: '14-2'
      },
      {
        path: '/policy/policyLibraryManagement/policyExpressMailSubscription',
        label: 'policyExpressMailSubscription',       // 政策速递邮件订阅管理
        permission: 'management_background_email',
        id: '14-3'
      },
      {
        path: '/policy/policyLibraryManagement/industryReport',
        label: 'industryReportManagement',       // 行业报告管理
        permission: 'management_background_indsutry_report',
        id: '14-4'
      }
    ]
  }
]
